import React from "react";
import { SkeletonBox, SkeletonText, SkeletonCard } from "./SkeletonBox";

/**
 * GenreChildPageSkeleton - Non-animated skeleton for inner Genre/Category content pages
 * 
 * Matches layout of:
 * - genreChild/content.js (Back button, title, content grid)
 * - genreParent/content.js (Similar structure with children)
 */

function skeletonElement(className) {
  return function SkeletonElement(props) {
    var mergedClassName = className + (props.className ? " " + props.className : "");
    return <div {...props} className={mergedClassName} />;
  };
}

var Container = skeletonElement("legacy-skeleton-page-container");
var HeaderRow = skeletonElement("legacy-skeleton-inline-row legacy-skeleton-header-row");
var BackButtonSkeleton = skeletonElement("legacy-skeleton-back-button legacy-skeleton-back-button-spaced");
var ContentGrid = skeletonElement("legacy-skeleton-wrap-row legacy-skeleton-genre-grid");
var CardWrapper = skeletonElement("legacy-skeleton-genre-card-wrap");
var SubGenreGrid = skeletonElement("legacy-skeleton-wrap-row legacy-skeleton-subgenre-grid");
var SubGenreChip = skeletonElement("legacy-skeleton-chip-wrap");

/**
 * Header with back button and title
 */
function HeaderSkeleton() {
  return (
    <HeaderRow>
      <BackButtonSkeleton />
      <SkeletonText width={200} size="xl" style={{ marginRight: 12 }} />
    </HeaderRow>
  );
}

/**
 * Sub-genre chips skeleton (for parent genres with children)
 */
function SubGenreChipsSkeleton({ count = 6 }) {
  var chips = [];
  var widths = [100, 80, 120, 90, 110, 85];

  for (var i = 0; i < count; i++) {
    chips.push(
      <SubGenreChip key={"subgenre_" + i}>
        <SkeletonBox
          width={widths[i % widths.length]}
          height={48}
          borderRadius={12}
        />
      </SubGenreChip>
    );
  }

  return (
    <SubGenreGrid>
      {chips}
    </SubGenreGrid>
  );
}

/**
 * Content cards grid skeleton
 */
function ContentGridSkeleton({ rows = 3, cols = 5 }) {
  var cards = [];
  var total = rows * cols;

  for (var i = 0; i < total; i++) {
    cards.push(
      <CardWrapper key={"card_" + i}>
        <div style={{
          width: "100%",
          height: 0,
          paddingTop: "140%",
          backgroundColor: "#262626",
          borderRadius: "16px",
        }} />
      </CardWrapper>
    );
  }

  return (
    <ContentGrid>
      {cards}
    </ContentGrid>
  );
}

/**
 * GenreChildPageSkeleton - Main export
 * @param {boolean} isParent - If true, shows sub-genre chips
 */
function GenreChildPageSkeleton({ isParent = false, rows = 3, cols = 5 }) {
  return (
    <Container>
      <HeaderSkeleton />
      {isParent && <SubGenreChipsSkeleton count={6} />}
      <ContentGridSkeleton rows={rows} cols={cols} />
    </Container>
  );
}

export { HeaderSkeleton, SubGenreChipsSkeleton, ContentGridSkeleton };
export default GenreChildPageSkeleton;
